import React from "react";
import PersonalNumber from "./PersonalNumber";

function ViewPriceSection({ activeTab }) {
  if (activeTab === 2) {
    return <PersonalNumber state_number={"2304"} />;  // 전기차
  } else if (activeTab === 1) {
    return <PersonalNumber state_number={"2101"} />;  // 개인넘버
  } else if (activeTab === 4) {
    return <PersonalNumber state_number={"2104"} />;  // 주선면허
  }
}

export default ViewPriceSection;
